export default function CStrings() {
  return <h2>C Strings</h2>;
}
